import { render, staticRenderFns } from "./addOrganizations.vue?vue&type=template&id=54b08441&scoped=true&"
import script from "./addOrganizations.vue?vue&type=script&lang=js&"
export * from "./addOrganizations.vue?vue&type=script&lang=js&"
import style0 from "./addOrganizations.vue?vue&type=style&index=0&id=54b08441&prod&lang=less&scoped=true&"
import style1 from "./addOrganizations.vue?vue&type=style&index=1&id=54b08441&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b08441",
  null
  
)

export default component.exports